<template>
  <div>
    <div class="main-view" v-loading.body="loading">
      <el-card class="searchCard" shadow="never">
        <!-- 筛选 -->
        <el-col>
          <el-form :inline="true" class="inline-form">
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="creatTime"
                class="el_date_picker"
                type="daterange"
                align="left"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="优惠券批次号">
              <el-input class="search-input" v-model="couponStockId" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="优惠券名称">
              <el-input class="search-input" v-model="couponName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select class="search-input" v-model="couponType" clearable>
                <el-option label="全场券" value="1"></el-option>
                <el-option label="单品券" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-card>
      <el-card class="tableCard" shadow="never">
        <!-- 代金券统计table -->
        <el-table
          stripe
          style="width:100%;"
          :data="voucherCountList"
          :header-cell-style="{background:'#FAFAFA'}">
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + 1"
            align="center"
            width="60">
          </el-table-column>
          <el-table-column
            prop="fCreateTime"
            label="创建时间"
            align="center"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="fCouponStockId"
            label="优惠券批次号"
            align="center"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="fCouponName"
            label="优惠券名称"
            align="center"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="fCouponType"
            label="类型"
            align="center"
            min-width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.fCouponType | formatCouponType }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="fCouponValue"
            label="代金券面额"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="fCouponMininumn"
            label="代金券使用最低限额"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="fMaxQuota"
            label="代金券最大领取数量"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="fCouponTotal"
            label="数量"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="fIsSendNum"
            label="已经发送数量"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="fBeginTime"
            label="生效开始时间"
            align="center"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="fEndTime"
            label="生效结束时间"
            align="center"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="fCouponStatus"
            label="代金券状态"
            align="center"
            min-width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.fCouponStatus | formatCouponStatus }}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-col :span="24" class="btm-action">
        <el-pagination
          v-if="paginations.count > 0"
          class="pagination"
          :page-size="paginations.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="paginations.count"
          :current-page="paginations.pageNo"
          @current-change="onChangeCurrentPage">
        </el-pagination>
      </el-col>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { merchantListWxcoupon } from '@/api/activity.js'

export default {
  name: 'MerchantWxVoucher',
  components: {},
  data () {
    return {
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            const end = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        FStartTime: '',
        FEndTime: '',
        FCouponStockId: '',
        FCouponName: '',
        FCouponType: ''
      },
      creatTime: '',
      couponStockId: '',
      couponName: '',
      couponType: '',
      voucherCountList: []
    }
  },
  mounted () {
    this.searchClick()
  },
  beforeDestroy () {},
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      this.searchInfo.FStartTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.FEndTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.FCouponStockId = this.couponStockId.replace(/ /g, '') || ''
      this.searchInfo.FCouponName = this.couponName.replace(/ /g, '') || ''
      this.searchInfo.FCouponType = this.couponType || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      this.searchInfo = Object.assign(this.searchInfo, this.paginations)
      this.queryWxcoupontList()
    },
    /**
     * 删除提交参数中的空字段
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 查询微信代金券统计列表
     */
    queryWxcoupontList () {
      return new Promise((resolve, reject) => {
        // this.loading = true
        const params = qs.stringify(this.searchInfo)
        console.log(params)
        merchantListWxcoupon(params).then(response => {
          console.log('merchantListWxcoupon response:', response)
          this.loading = false
          if (response.error_code === '0') {
            this.voucherCountList = response.list
            this.paginations.count = response.totalCount
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    }
  },
  computed: {},
  filters: {
    formatCouponType (value) {
      switch (value) {
        case 1:
          return '全场券'
        case 2:
          return '单品券'
        default:
          return '未知'
      }
    },
    formatCouponStatus (value) {
      switch (value) {
        case 1:
          return '未激活'
        case 2:
          return '审批中'
        case 4:
          return '已激活'
        case 8:
          return '已作废'
        case 16:
          return '中止发放'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
</style>
